import moment from 'moment/moment';

import download from 'downloadjs';
import { types } from '../constants/filter';
import { DATES } from '../constants/common';
import { extractMetaFor } from './filter';
import { CSV_FILE_DESCRIPTION } from './csv';

const prepareDropdownFields = (metainf) =>
  metainf.groups.map((g) => ({
    title: g.label,
    fields: g.fields.map((f) => ({
      value: f.path,
      name: f.label,
      type: metainf.meta[f.path].type,
    })),
  }));

const filterMetainfFields = (metainf, excludeNonPrimitive, excludeFieldTypes) => ({
  ...metainf,
  groups: metainf.groups
    .map((g) => ({
      ...g,
      fields: g.fields
        .filter((f) => !excludeFieldTypes.includes(metainf.meta[f.path].type))
        .filter((f) => !(metainf.meta[f.path].type === types.LIST && excludeNonPrimitive)),
    }))
    .filter((g) => g.fields.length > 0),
});

export const prepareDropdown = (metainf, excludeNonPrimitive, excludeFieldTypes = []) => {
  const filteredMetainfoFields = filterMetainfFields(
    metainf,
    excludeNonPrimitive,
    excludeFieldTypes
  );
  return prepareDropdownFields(filteredMetainfoFields);
};

export const formatJSON = (text) => {
  if (!text) {
    return text;
  }

  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch (e) {
    return text;
  }
};

export const decomposeMillis = (value) => {
  const momentValue = moment.duration(value);

  const days = Math.floor(momentValue.asDays());
  momentValue.subtract(days, 'days');

  const hours = Math.floor(momentValue.asHours());
  momentValue.subtract(hours, 'hours');

  const minutes = Math.floor(momentValue.asMinutes());
  momentValue.subtract(minutes, 'minutes');

  const seconds = Math.floor(momentValue.asSeconds());

  return { days, hours, minutes, seconds };
};

export const isInDevMode = () => process.env.NODE_ENV !== 'production';

export const getTenantFromPath = (path) => (path ? (path.match('^/([^/]*)') || ['']).pop() : '');

export const firstPathElement = (path) => `/${getTenantFromPath(path)}`;

export const extractTypeFor = (field, metainf) => {
  if (!field) {
    return undefined;
  }

  if (DATES.includes(field)) {
    return types.DATE;
  }

  // In case we didn't find anything, return default NUMBER type
  // There is at least one case we won't be able to find meta: when
  // column's function contains constant or expression
  return extractMetaFor(field, metainf).type !== undefined
    ? extractMetaFor(field, metainf).type
    : { type: types.NUMBER }.type;
};

export const isFieldOfDateType = (field, metainf) => extractTypeFor(field, metainf) === types.DATE;

export const average = (values) => values.reduce((a, b) => a + b, 0) / values.length;

export const median = (values) => {
  const sortedValues = values.sort((a, b) => a - b);
  const half = Math.floor(sortedValues.length / 2);
  if (sortedValues.length % 2) {
    return sortedValues[half];
  }
  return (sortedValues[half - 1] + sortedValues[half]) / 2;
};

export const stringifyNull = (v) => {
  if (v === null) {
    return 'null';
  }
  return v;
};

export function textToClipboard(text) {
  const dummy = document.createElement('textarea');
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
}

export const getEventFieldPath = (field) => (field ? field.path.replace('event.', '') : field);

export const divideIntoNumericDigits = (number) =>
  number ? number.toLocaleString('ru').replace(',', '.') : 0;

export const downloadCsv = (csv) => {
  download(csv, 'result.csv', CSV_FILE_DESCRIPTION);
};
